const products = {
  WEBSITE: "https://www.youstad.com",
  LEDGER: "https://ledger.youstad.com",
  DOCKET: "https://docket.youstad.com",
  BITE: "https://bite.youstad.com",
};

export default products;
